/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  TestERC721AQueryable,
  TestERC721AQueryableInterface,
} from "../../../contracts/test/TestERC721AQueryable";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidQueryRange",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "explicitOwnershipOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721A.TokenOwnership",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "explicitOwnershipsOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721A.TokenOwnership[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stop",
        type: "uint256",
      },
    ],
    name: "tokensOfOwnerIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestERC721AQueryableConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestERC721AQueryableConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestERC721AQueryable__factory extends ContractFactory {
  constructor(...args: TestERC721AQueryableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TestERC721AQueryable> {
    return super.deploy(overrides || {}) as Promise<TestERC721AQueryable>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TestERC721AQueryable {
    return super.attach(address) as TestERC721AQueryable;
  }
  override connect(signer: Signer): TestERC721AQueryable__factory {
    return super.connect(signer) as TestERC721AQueryable__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestERC721AQueryableInterface {
    return new utils.Interface(_abi) as TestERC721AQueryableInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestERC721AQueryable {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestERC721AQueryable;
  }
}
